import { useCallback } from "react"
import { useClienteApi } from "../../infra/cliente"
import { useLimitacaoConsumoApi } from "../../infra/limitacao-consumo"
import { useUserApi } from "../../infra/user"
import { usePerfilApi } from "../../infra/perfil"
import { useAppDispatch, useAppSelector } from "../../presentation/hooks/store-hooks"
import { useNavigationService } from "../navigation"
import { useUIService } from "../ui"
import {
    resetClienteSelecionadoState,
    resetCreateLimitacaoConsumoClienteFormState,
    resetLimitacaoConsumoTotalState,
    resetLimitacaoConsumoPaginationState,
    resetUpdateLimitacaoConsumoClienteFormState,
    setClienteSelecionadoState,
    setCreateLimitacaoConsumoClienteFormErrorsState,
    setCreateLimitacaoConsumoClienteFormIdClienteState,
    setCreateLimitacaoConsumoClienteFormIdProdutoState,
    setCreateLimitacaoConsumoClienteFormIdTipoConsumoState,
    setCreateLimitacaoConsumoClienteFormModoTravaClienteState,
    setCreateLimitacaoConsumoClienteFormQuantidadeState,
    setCreateLimitacaoConsumoClienteFormIsGrupoState,
    setCreateLimitacaoConsumoClienteFormTouchedState,
    setCreateLimitacaoConsumoClienteOpenFormState,
    setLimitacaoConsumoLimitState,
    setLimitacaoConsumoPageState,
    setLimitacaoConsumoClientesState,
    setLimitacaoConsumoState,
    setLimitacaoConsumoTotalState,
    setLimitacaoConsumoPaginationState,
    setLimitacaoConsumoUsuariosState,
    setUpdateLimitacaoConsumoClienteFormAtivoState,
    setUpdateLimitacaoConsumoClienteFormErrorsState,
    setUpdateLimitacaoConsumoClienteFormIdLimitacaoConsumoClienteState,
    setUpdateLimitacaoConsumoClienteFormQuantidadeState,
    setUpdateLimitacaoConsumoClienteFormTouchedState,
    setUpdateLimitacaoConsumoClienteFormIdGrupoTravaState,
    setUpdateLimitacaoConsumoClienteFormIdClienteState,
    setUpdateLimitacaoConsumoClienteOpenFormState,
    validateCreateLimitacaoConsumoClienteForm,
    validateUpdateLimitacaoConsumoClienteForm,
    setCreateLimitacaoConsumoUsuarioFormIdUsuarioState,
    setCreateLimitacaoConsumoUsuarioFormIdProdutoState,
    setCreateLimitacaoConsumoUsuarioFormIdTipoConsumoState,
    setCreateLimitacaoConsumoUsuarioFormIsGrupoState,
    setCreateLimitacaoConsumoUsuarioFormQuantidadeState,
    setUpdateLimitacaoConsumoUsuarioFormIdLimitacaoConsumoUsuarioState,
    setUpdateLimitacaoConsumoUsuarioFormIdUsuarioState,
    setUpdateLimitacaoConsumoUsuarioFormAtivoState,
    setUpdateLimitacaoConsumoUsuarioFormQuantidadeState,
    setUpdateLimitacaoConsumoUsuarioFormIdGrupoTravaState,
    setCreateLimitacaoConsumoUsuarioOpenFormState,
    resetCreateLimitacaoConsumoUsuarioFormState,
    setUpdateLimitacaoConsumoUsuarioOpenFormState,
    resetUpdateLimitacaoConsumoUsuarioFormState,
    validateCreateLimitacaoConsumoUsuarioForm,
    setCreateLimitacaoConsumoUsuarioFormErrorsState,
    setCreateLimitacaoConsumoUsuarioFormTouchedState,
    validateUpdateLimitacaoConsumoUsuarioForm,
    setUpdateLimitacaoConsumoUsuarioFormErrorsState,
    setUpdateLimitacaoConsumoUsuarioFormTouchedState,
    setUsuarioSelecionadoState,
    resetUsuarioSelecionadoState,
    setLimitacaoConsumoPerfisState,
    resetLimitacaoConsumoPerfisState,
    setPerfilSelecionadoState,
    resetPerfilSelecionadoState,
    setProdutoLimitacaoConsumoListState,
    resetProdutoLimitacaoConsumoListState,
    resetCreateLimitacaoConsumoClienteFormErrorsState,
    resetLimitacaoConsumoState,
    resetCreateLimitacaoConsumoUsuarioFormErrorsState,
    setCreateLimitacaoConsumoClienteFormIdUsuarioState,
    setCreateLimitacaoConsumoPerfilOpenFormState,
    setCreateLimitacaoConsumoPerfilFormIdPerfilState,
    setCreateLimitacaoConsumoPerfilFormIdUsuarioState,
    setCreateLimitacaoConsumoPerfilFormIdProdutoState,
    setCreateLimitacaoConsumoPerfilFormIdTipoConsumoState,
    setCreateLimitacaoConsumoPerfilFormIsGrupoState,
    setCreateLimitacaoConsumoPerfilFormQuantidadeState,
    resetCreateLimitacaoConsumoPerfilFormState,
    setUpdateLimitacaoConsumoPerfilOpenFormState,
    setUpdateLimitacaoConsumoPerfilFormIdLimitacaoConsumoPerfilState,
    setUpdateLimitacaoConsumoPerfilFormIdPerfilState,
    setUpdateLimitacaoConsumoPerfilFormQuantidadeState,
    setUpdateLimitacaoConsumoPerfilFormAtivoState,
    setUpdateLimitacaoConsumoPerfilFormIdGrupoTravaState,
    resetUpdateLimitacaoConsumoPerfilFormState
} from "../../application/states/limitacao-consumo"
import type { IModoTravaCliente } from "../../application/states/limitacao-consumo"
import { ICliente, ILimitacaoConsumoTable, IUsuario } from "../../application/models"
import { useProdutoLimitacaoConsumoApi } from "../../infra/produto-limitacao-consumo"

export const useLimitacaoConsumoService = (): any => {
    // Dispatch
    const dispatch = useAppDispatch()
    // Navigate
    const { navigateTo } = useNavigationService()
    // State
    const { currentUser } = useAppSelector((state: any) => state.user)
    const {
        createLimitacaoConsumoClienteForm,
        updateLimitacaoConsumoClienteForm,
        createLimitacaoConsumoUsuarioForm,
        updateLimitacaoConsumoUsuarioForm,
        createLimitacaoConsumoPerfilForm,
        updateLimitacaoConsumoPerfilForm,
        clienteSelecionado,
        limitacaoConsumoPagination,
        usuarioSelecionado
    } = useAppSelector((state: any) => state.limitacaoConsumo)
    // API
    const { getClientesListApi } = useClienteApi()
    const { getAllUsuariosAtivosByIdClienteApi } = useUserApi()
    const { getPerfisByIdClienteApi } = usePerfilApi()
    const {
        createLimitacaoConsumoClienteApi,
        findLimitacaoConsumoClienteApi,
        updateLimitacaoConsumoClienteApi,
        createLimitacaoConsumoUsuarioApi,
        findLimitacaoConsumoUsuarioApi,
        updateLimitacaoConsumoUsuarioApi,
        createLimitacaoConsumoPerfilApi,
        findLimitacaoConsumoPerfilApi,
        updateLimitacaoConsumoPerfilApi
    } = useLimitacaoConsumoApi()
    const { produtoLimitacaoConsumoGetAllAtivosApi } = useProdutoLimitacaoConsumoApi()
    // Service
    const { setLoading, setAlert } = useUIService()

    const getApiErrorMessage = (error: any): string => {
        const data = error?.response?.data

        if (data?.key && data?.value) {
            const value = typeof data.value === 'string' ? data.value : String(data.value ?? '')
            return `${data.key}: ${value}`
        }
        if (typeof data?.value === 'string' && data.value) return data.value
        if (typeof data?.message === 'string' && data.message) return data.message
        if (typeof data?.error === 'string' && data.error) return data.error
        if (data?.error && typeof data.error === 'object' && typeof (data.error as { message?: unknown }).message === 'string') {
            return (data.error as { message: string }).message
        }

        if (error?.message) return String(error.message)
        return 'Erro inesperado ao processar a solicitação.'
    }

    // Functions
    const createLimitacaoConsumoCliente = useCallback(async () => {
        if (currentUser) {
            dispatch(resetCreateLimitacaoConsumoClienteFormErrorsState())

            const loadingId = Math.random().toString()
            try {
                let errors = [...validateCreateLimitacaoConsumoClienteForm(createLimitacaoConsumoClienteForm.fields)]

                const porTipoConsumo = createLimitacaoConsumoClienteForm.fields.ModoTravaCliente === 'tipoConsumo'
                const isGrupo = createLimitacaoConsumoClienteForm.fields.IsGrupo
                const qtdTiposSelecionados = createLimitacaoConsumoClienteForm.fields.IdTipoConsumo?.length

                if (porTipoConsumo && !isGrupo && qtdTiposSelecionados > 0 && createLimitacaoConsumoClienteForm.fields.Quantidade < qtdTiposSelecionados) {
                    const idx = errors.findIndex(e => e.key === 'Quantidade')
                    if (idx !== -1) errors.splice(idx, 1)
                    
                    errors.push({
                        key: 'Quantidade',
                        message: `A quantidade deve ser de pelo menos ${qtdTiposSelecionados} para os tipos de consumo selecionados.`
                    })
                }

                if (errors.length > 0) {
                    dispatch(setCreateLimitacaoConsumoClienteFormErrorsState(errors))

                    dispatch(setCreateLimitacaoConsumoClienteFormTouchedState(true))

                    const errQuantidade = errors.find(item => item.key === 'Quantidade')
                    const errProduto = errors.find(item => item.key === 'IdProduto')
                    const errTipo = errors.find(item => item.key === 'IdTipoConsumo')
                    
                    if (errQuantidade) {
                        setAlert({
                            message: errQuantidade.message,
                            type: 'error'
                        })
                    } else if (errProduto) {
                        setAlert({
                            message: errProduto.message,
                            type: 'error'
                        })
                    } else if (errTipo) {
                        setAlert({
                            message: errTipo.message,
                            type: 'error'
                        })
                    }
                } else {
                    setLoading({
                        id: loadingId,
                        loading: true,
                        message: 'Registrando trava de consumo para o cliente...'
                    })

                    const modoTrava = createLimitacaoConsumoClienteForm.fields.ModoTravaCliente
                    const isGrupo = createLimitacaoConsumoClienteForm.fields.IsGrupo
                    const porTipoConsumo = modoTrava === 'tipoConsumo'
                    const payload = {
                        IdCliente: createLimitacaoConsumoClienteForm.fields.IdCliente,
                        IdUsuario: createLimitacaoConsumoClienteForm.fields.IdUsuario,
                        IdProduto: (porTipoConsumo && !isGrupo) ? null : createLimitacaoConsumoClienteForm.fields.IdProduto,
                        Quantidade: createLimitacaoConsumoClienteForm.fields.Quantidade,
                        IdTipoConsumo: (porTipoConsumo || isGrupo) ? createLimitacaoConsumoClienteForm.fields.IdTipoConsumo : null,
                        IsGrupo: isGrupo,
                        isGrupo: isGrupo
                    }

                    await createLimitacaoConsumoClienteApi(payload)

                    dispatch(resetCreateLimitacaoConsumoClienteFormState())
                    setAlert({
                        message: 'Trava de consumo criada com sucesso',
                        type: 'success'
                    })

                    navigateTo({
                        route: '/dashboard/trava/consumo'
                    })

                    dispatch(setCreateLimitacaoConsumoClienteOpenFormState(false))
                    dispatch(resetLimitacaoConsumoState())
                    dispatch(resetClienteSelecionadoState())
                    dispatch(resetUsuarioSelecionadoState())
                }

            } catch (error: any) {
                setAlert({
                    message: getApiErrorMessage(error),
                    type: 'error'
                })
            } finally {
                setLoading({
                    id: loadingId,
                    loading: false
                })
            }
        }

    }, [createLimitacaoConsumoClienteApi, createLimitacaoConsumoClienteForm.fields, currentUser, dispatch, navigateTo, setAlert, setLoading])

    const updateLimitacaoConsumoCliente = useCallback(async () => {
        if (currentUser) {
            const loadingId = Math.random().toString()

            try {
                const errors = validateUpdateLimitacaoConsumoClienteForm(updateLimitacaoConsumoClienteForm.fields)

                if (errors.length > 0) {
                    dispatch(setUpdateLimitacaoConsumoClienteFormErrorsState(errors))

                    dispatch(setUpdateLimitacaoConsumoClienteFormTouchedState(true))
                } else {
                    setLoading({
                        id: loadingId,
                        loading: true,
                        message: 'Atualizando trava de consumo...'
                    })

                    await updateLimitacaoConsumoClienteApi({
                        Ativo: updateLimitacaoConsumoClienteForm.fields.Ativo,
                        IdLimitacaoConsumoCliente: updateLimitacaoConsumoClienteForm.fields.IdLimitacaoConsumoCliente,
                        Quantidade: updateLimitacaoConsumoClienteForm.fields.Quantidade,
                        IdCliente: updateLimitacaoConsumoClienteForm.fields.IdCliente || currentUser.IdCliente,
                        IdUsuario: currentUser.IdUsuario,
                        IdGrupoTrava: updateLimitacaoConsumoClienteForm.fields.IdGrupoTrava
                    })

                    dispatch(resetUpdateLimitacaoConsumoClienteFormState())

                    setAlert({
                        message: 'Trava de consumo atualizada com sucesso',
                        type: 'success'
                    })

                    navigateTo({
                        route: '/dashboard/trava/consumo'
                    })

                    dispatch(setUpdateLimitacaoConsumoClienteOpenFormState(false))
                    dispatch(resetLimitacaoConsumoState())
                    dispatch(resetClienteSelecionadoState())
                    dispatch(resetUsuarioSelecionadoState())
                }
            } catch (error: any) {
                setAlert({
                    message: getApiErrorMessage(error),
                    type: 'error'
                })
            } finally {
                setLoading({
                    id: loadingId,
                    loading: false
                })
            }
        }
    }, [currentUser, dispatch, navigateTo, setAlert, setLoading, updateLimitacaoConsumoClienteApi, updateLimitacaoConsumoClienteForm.fields])

    const findLimitacaoConsumoCliente = useCallback(async () => {
        if (currentUser) {
            if (clienteSelecionado) {
                const loadingId = Math.random().toString()

                try {
                    setLoading({
                        id: loadingId,
                        loading: true,
                        message: 'Buscando travas de consumo para o cliente selecionado...'
                    })

                    const clientList = await findLimitacaoConsumoClienteApi({
                        IdCliente: clienteSelecionado.IdCliente,
                        IdUsuario: currentUser.IdUsuario,
                        Limit: limitacaoConsumoPagination.limit,
                        Page: limitacaoConsumoPagination.page
                    })

                    const limitacaoConsumoList: ILimitacaoConsumoTable[] = []

                    const rows = clientList?.LimitacaoConsumo ?? []
                    rows.forEach((limitacaoConsumo) => limitacaoConsumoList.push({
                        Ativo: limitacaoConsumo.Ativo,
                        Atualizacao: limitacaoConsumo.Atualizacao,
                        Descricao: limitacaoConsumo.Descricao,
                        DescricaoProduto:
                            limitacaoConsumo.DescricaoProduto ??
                            (limitacaoConsumo.IdProduto != null && limitacaoConsumo.Descricao ? limitacaoConsumo.Descricao : null),
                        IdLimitacaoConsumo: limitacaoConsumo.IdLimitacaoConsumoCliente ?? limitacaoConsumo.IdGrupoTrava,
                        IdGrupoTrava: limitacaoConsumo.IdGrupoTrava,
                        IdProduto: limitacaoConsumo.IdProduto ?? null,
                        IdTipoConsumo: limitacaoConsumo.IdTipoConsumo ?? null,
                        Inclusao: limitacaoConsumo.Inclusao,
                        Login: limitacaoConsumo.LoginCliente,
                        Quantidade: limitacaoConsumo.Quantidade,
                        IdCliente: limitacaoConsumo.IdCliente,
                        IdUsuario: currentUser.IdUsuario
                    }))

                    const grupoTravaMap = new Map<number, ILimitacaoConsumoTable>()
                    const groupedList: ILimitacaoConsumoTable[] = []
                    limitacaoConsumoList.forEach((item) => {
                        if (item.IdGrupoTrava != null) {
                            const existing = grupoTravaMap.get(item.IdGrupoTrava)
                            if (existing) {
                                existing.subRows!.push(item)
                            } else {
                                const parentRow: ILimitacaoConsumoTable = {
                                    IdLimitacaoConsumo: item.IdGrupoTrava,
                                    IdGrupoTrava: item.IdGrupoTrava,
                                    IdCliente: item.IdCliente,
                                    IdUsuario: item.IdUsuario,
                                    DescricaoProduto: item.DescricaoProduto,
                                    Descricao: item.DescricaoProduto ?? item.Descricao,
                                    IdProduto: item.IdProduto ?? null,
                                    Quantidade: item.Quantidade,
                                    Ativo: item.Ativo,
                                    Inclusao: item.Inclusao,
                                    Atualizacao: item.Atualizacao,
                                    Login: item.Login,
                                    subRows: [item]
                                }
                                grupoTravaMap.set(item.IdGrupoTrava, parentRow)
                                groupedList.push(parentRow)
                            }
                        } else {
                            groupedList.push(item)
                        }
                    })

                    dispatch(setLimitacaoConsumoState(groupedList))
                    dispatch(setLimitacaoConsumoTotalState(clientList?.Total ?? 0))

                } catch (error: any) {
                    setAlert({
                        message: getApiErrorMessage(error),
                        type: 'error'
                    })
                } finally {
                    setLoading({
                        id: loadingId,
                        loading: false
                    })
                }
            }
        }
    }, [clienteSelecionado, limitacaoConsumoPagination.limit, limitacaoConsumoPagination.page, currentUser, dispatch, findLimitacaoConsumoClienteApi, setAlert, setLoading])

    const createLimitacaoConsumoUsuario = useCallback(async () => {
        if (currentUser) {
            dispatch(resetCreateLimitacaoConsumoUsuarioFormErrorsState())

            const loadingId = Math.random().toString()
            try {
                let errors = [...validateCreateLimitacaoConsumoUsuarioForm(createLimitacaoConsumoUsuarioForm.fields)]

                const isGrupo = createLimitacaoConsumoUsuarioForm.fields.IsGrupo
                const porVariavel = (createLimitacaoConsumoUsuarioForm.fields.IdTipoConsumo ?? []).length > 0
                const qtdTiposSelecionados = createLimitacaoConsumoUsuarioForm.fields.IdTipoConsumo?.length || 0

                if (porVariavel && !isGrupo && qtdTiposSelecionados > 0 && createLimitacaoConsumoUsuarioForm.fields.Quantidade < qtdTiposSelecionados) {
                    const idx = errors.findIndex(e => e.key === 'Quantidade')
                    if (idx !== -1) errors.splice(idx, 1)
                    
                    errors.push({
                        key: 'Quantidade',
                        message: `A quantidade deve ser de pelo menos ${qtdTiposSelecionados} para os tipos de consumo selecionados.`
                    })
                }

                if (errors.length > 0) {
                    dispatch(setCreateLimitacaoConsumoUsuarioFormErrorsState(errors))

                    dispatch(setCreateLimitacaoConsumoUsuarioFormTouchedState(true))

                    const errQuantidade = errors.find(item => item.key === 'Quantidade')
                    const errProduto = errors.find((item: any) => item.key === 'IdProduto')
                    const errTipo = errors.find((item: any) => item.key === 'IdTipoConsumo')

                    if (errQuantidade) {
                        setAlert({
                            message: errQuantidade.message,
                            type: 'error'
                        })
                    } else if (errProduto) {
                        setAlert({
                            message: errProduto.message || 'Selecione um produto',
                            type: 'error'
                        })
                    } else if (errTipo) {
                        setAlert({
                            message: errTipo.message,
                            type: 'error'
                        })
                    }
                } else {
                    setLoading({
                        id: loadingId,
                        loading: true,
                        message: 'Registrando trava de consumo para o usuário...'
                    })

                    const isGrupo = createLimitacaoConsumoUsuarioForm.fields.IsGrupo
                    const payload = {
                        IdUsuario: createLimitacaoConsumoUsuarioForm.fields.IdUsuario,
                        IdProduto: (porVariavel && !isGrupo) ? null : createLimitacaoConsumoUsuarioForm.fields.IdProduto,
                        Quantidade: createLimitacaoConsumoUsuarioForm.fields.Quantidade,
                        IdTipoConsumo: (porVariavel || isGrupo) ? (createLimitacaoConsumoUsuarioForm.fields.IdTipoConsumo ?? []) : null,
                        IsGrupo: isGrupo
                    }
                    await createLimitacaoConsumoUsuarioApi(payload)

                    dispatch(resetCreateLimitacaoConsumoUsuarioFormState())
                    setAlert({
                        message: 'Trava de consumo criada com sucesso',
                        type: 'success'
                    })

                    navigateTo({
                        route: '/dashboard/trava/consumo'
                    })

                    dispatch(setCreateLimitacaoConsumoUsuarioOpenFormState(false))
                    dispatch(resetLimitacaoConsumoState())
                    dispatch(resetClienteSelecionadoState())
                    dispatch(resetUsuarioSelecionadoState())
                }

            } catch (error: any) {
                setAlert({
                    message: getApiErrorMessage(error),
                    type: 'error'
                })
            } finally {
                setLoading({
                    id: loadingId,
                    loading: false
                })
            }
        }

    }, [createLimitacaoConsumoUsuarioApi, createLimitacaoConsumoUsuarioForm.errors, createLimitacaoConsumoUsuarioForm.fields, currentUser, dispatch, navigateTo, setAlert, setLoading])

    const updateLimitacaoConsumoUsuario = useCallback(async () => {
        if (currentUser) {
            const loadingId = Math.random().toString()

            try {
                const errors = validateUpdateLimitacaoConsumoUsuarioForm(updateLimitacaoConsumoUsuarioForm.fields)

                if (errors.length > 0) {
                    dispatch(setUpdateLimitacaoConsumoUsuarioFormErrorsState(errors))

                    dispatch(setUpdateLimitacaoConsumoUsuarioFormTouchedState(true))
                } else {
                    setLoading({
                        id: loadingId,
                        loading: true,
                        message: 'Atualizando trava de consumo...'
                    })

                    await updateLimitacaoConsumoUsuarioApi({
                        Ativo: updateLimitacaoConsumoUsuarioForm.fields.Ativo,
                        IdLimitacaoConsumoUsuario: updateLimitacaoConsumoUsuarioForm.fields.IdLimitacaoConsumoUsuario,
                        Quantidade: updateLimitacaoConsumoUsuarioForm.fields.Quantidade,
                        IdUsuario: currentUser.IdUsuario,
                        IdGrupoTrava: updateLimitacaoConsumoUsuarioForm.fields.IdGrupoTrava
                    })

                    dispatch(resetUpdateLimitacaoConsumoUsuarioFormState())

                    setAlert({
                        message: 'Trava de consumo atualizada com sucesso',
                        type: 'success'
                    })

                    navigateTo({
                        route: '/dashboard/trava/consumo'
                    })

                    dispatch(setUpdateLimitacaoConsumoUsuarioOpenFormState(false))
                    dispatch(resetLimitacaoConsumoState())
                    dispatch(resetClienteSelecionadoState())
                    dispatch(resetUsuarioSelecionadoState())
                }
            } catch (error: any) {
                setAlert({
                    message: getApiErrorMessage(error),
                    type: 'error'
                })
            } finally {
                setLoading({
                    id: loadingId,
                    loading: false
                })
            }
        }
    }, [currentUser, dispatch, navigateTo, setAlert, setLoading, updateLimitacaoConsumoUsuarioApi, updateLimitacaoConsumoUsuarioForm.fields])

    const findLimitacaoConsumoUsuario = useCallback(async () => {
        if (currentUser) {
            if (usuarioSelecionado) {
                const loadingId = Math.random().toString()

                try {
                    setLoading({
                        id: loadingId,
                        loading: true,
                        message: 'Buscando travas de consumo para o usuário selecionado...'
                    })

                    const list = await findLimitacaoConsumoUsuarioApi({
                        IdUsuario: usuarioSelecionado.IdUsuario,
                        Limit: limitacaoConsumoPagination.limit,
                        Page: limitacaoConsumoPagination.page
                    })

                    const limitacaoConsumoList: ILimitacaoConsumoTable[] = []

                    list.LimitacaoConsumo.forEach((limitacaoConsumo) => limitacaoConsumoList.push({
                        Ativo: limitacaoConsumo.Ativo,
                        Atualizacao: limitacaoConsumo.Atualizacao,
                        Descricao: limitacaoConsumo.Descricao,
                        DescricaoProduto: limitacaoConsumo.DescricaoProduto,
                        IdLimitacaoConsumo: limitacaoConsumo.IdLimitacaoConsumoUsuario || limitacaoConsumo.IdGrupoTrava,
                        IdGrupoTrava: limitacaoConsumo.IdGrupoTrava,
                        IdProduto: limitacaoConsumo.IdProduto,
                        IdTipoConsumo: limitacaoConsumo.IdTipoConsumo,
                        Inclusao: limitacaoConsumo.Inclusao,
                        Login: limitacaoConsumo.LoginUsuario,
                        Quantidade: limitacaoConsumo.Quantidade,
                        IdUsuario: limitacaoConsumo.IdUsuario,
                        IdCliente: currentUser.IdCliente,
                    }))

                    const grupoTravaMapUsuario = new Map<number, ILimitacaoConsumoTable>()
                    const groupedListUsuario: ILimitacaoConsumoTable[] = []
                    limitacaoConsumoList.forEach((item) => {
                        if (item.IdGrupoTrava != null) {
                            const existing = grupoTravaMapUsuario.get(item.IdGrupoTrava)
                            if (existing) {
                                existing.subRows!.push(item)
                            } else {
                                const parentRow: ILimitacaoConsumoTable = {
                                    IdLimitacaoConsumo: item.IdGrupoTrava,
                                    IdGrupoTrava: item.IdGrupoTrava,
                                    IdCliente: item.IdCliente,
                                    IdUsuario: item.IdUsuario,
                                    DescricaoProduto: item.DescricaoProduto,
                                    Descricao: item.DescricaoProduto || item.Descricao,
                                    IdProduto: item.IdProduto,
                                    Quantidade: item.Quantidade,
                                    Ativo: item.Ativo,
                                    Inclusao: item.Inclusao,
                                    Atualizacao: item.Atualizacao,
                                    Login: item.Login,
                                    subRows: [item]
                                }
                                grupoTravaMapUsuario.set(item.IdGrupoTrava, parentRow)
                                groupedListUsuario.push(parentRow)
                            }
                        } else {
                            groupedListUsuario.push(item)
                        }
                    })

                    dispatch(setLimitacaoConsumoState(groupedListUsuario))
                    dispatch(setLimitacaoConsumoTotalState(list.Total))

                } catch (error: any) {
                    setAlert({
                        message: getApiErrorMessage(error),
                        type: 'error'
                    })
                } finally {
                    setLoading({
                        id: loadingId,
                        loading: false
                    })
                }
            }
        }
    }, [usuarioSelecionado, limitacaoConsumoPagination.limit, limitacaoConsumoPagination.page, currentUser, dispatch, findLimitacaoConsumoUsuarioApi, setAlert, setLoading])

    const findLimitacaoConsumoPerfil = useCallback(async (IdPerfil: number) => {
        if (!currentUser) return
        const loadingId = Math.random().toString()

        try {
            setLoading({
                id: loadingId,
                loading: true,
                message: 'Buscando travas de consumo para o perfil selecionado...'
            })

            const list = await findLimitacaoConsumoPerfilApi({
                IdPerfil,
                Limit: limitacaoConsumoPagination.limit,
                Page: limitacaoConsumoPagination.page
            })

            const limitacaoConsumoList: ILimitacaoConsumoTable[] = []
            list.LimitacaoConsumo.forEach((row) => limitacaoConsumoList.push({
                Ativo: row.Ativo,
                Atualizacao: row.Atualizacao,
                Descricao: row.Descricao,
                DescricaoProduto: row.DescricaoProduto,
                IdLimitacaoConsumo: row.IdLimitacaoConsumoPerfil || row.IdGrupoTrava,
                IdGrupoTrava: row.IdGrupoTrava,
                IdProduto: row.IdProduto,
                IdTipoConsumo: row.IdTipoConsumo,
                Inclusao: row.Inclusao,
                Login: row.DescricaoPerfil!,
                Quantidade: row.Quantidade,
                IdUsuario: currentUser.IdUsuario,
                IdCliente: currentUser.IdCliente
            }))

            const grupoTravaMapPerfil = new Map<number, ILimitacaoConsumoTable>()
            const groupedListPerfil: ILimitacaoConsumoTable[] = []
            limitacaoConsumoList.forEach((item) => {
                if (item.IdGrupoTrava != null) {
                    const existing = grupoTravaMapPerfil.get(item.IdGrupoTrava)
                    if (existing) {
                        existing.subRows!.push(item)
                    } else {
                        const parentRow: ILimitacaoConsumoTable = {
                            IdLimitacaoConsumo: item.IdGrupoTrava,
                            IdGrupoTrava: item.IdGrupoTrava,
                            IdCliente: item.IdCliente,
                            IdUsuario: item.IdUsuario,
                            DescricaoProduto: item.DescricaoProduto,
                            Descricao: item.DescricaoProduto || item.Descricao,
                            IdProduto: item.IdProduto,
                            Quantidade: item.Quantidade,
                            Ativo: item.Ativo,
                            Inclusao: item.Inclusao,
                            Atualizacao: item.Atualizacao,
                            Login: item.Login,
                            subRows: [item]
                        }
                        grupoTravaMapPerfil.set(item.IdGrupoTrava, parentRow)
                        groupedListPerfil.push(parentRow)
                    }
                } else {
                    groupedListPerfil.push(item)
                }
            })

            dispatch(setLimitacaoConsumoState(groupedListPerfil))
            dispatch(setLimitacaoConsumoTotalState(list.Total))
        } catch (error: any) {
            setAlert({
                message: getApiErrorMessage(error),
                type: 'error'
            })
        } finally {
            setLoading({
                id: loadingId,
                loading: false
            })
        }
    }, [currentUser, dispatch, findLimitacaoConsumoPerfilApi, limitacaoConsumoPagination.limit, limitacaoConsumoPagination.page, setAlert, setLoading])

    const createLimitacaoConsumoPerfil = useCallback(async (data: {
        IdPerfil: number
        Quantidade: number
        IdProduto: number | null
        IdTipoConsumo: number[] | null
        IsGrupo: boolean
    }) => {
        if (!currentUser) return
        const loadingId = Math.random().toString()

        try {
            setLoading({
                id: loadingId,
                loading: true,
                message: 'Registrando trava de consumo para o perfil...'
            })

            await createLimitacaoConsumoPerfilApi({
                IdPerfil: data.IdPerfil,
                IdUsuario: currentUser.IdUsuario,
                Quantidade: data.Quantidade,
                IdProduto: data.IdProduto,
                IdTipoConsumo: data.IdTipoConsumo,
                IsGrupo: data.IsGrupo
            })

            dispatch(resetCreateLimitacaoConsumoPerfilFormState())

            setAlert({
                message: 'Trava de consumo criada com sucesso',
                type: 'success'
            })

            navigateTo({
                route: '/dashboard/trava/consumo'
            })

            dispatch(setCreateLimitacaoConsumoPerfilOpenFormState(false))
            dispatch(resetLimitacaoConsumoState())
            dispatch(resetClienteSelecionadoState())
            dispatch(resetUsuarioSelecionadoState())
            dispatch(resetPerfilSelecionadoState())
        } catch (error: any) {
            setAlert({
                message: getApiErrorMessage(error),
                type: 'error'
            })
        } finally {
            setLoading({
                id: loadingId,
                loading: false
            })
        }
    }, [createLimitacaoConsumoPerfilApi, currentUser, dispatch, navigateTo, setAlert, setLoading])

    const updateLimitacaoConsumoPerfil = useCallback(async () => {
        if (!currentUser) return

        const { IdLimitacaoConsumoPerfil, IdGrupoTrava, IdPerfil, Quantidade, Ativo } = updateLimitacaoConsumoPerfilForm.fields
        const isGrupo = IdGrupoTrava != null && IdGrupoTrava > 0

        if (!isGrupo && (!IdLimitacaoConsumoPerfil || IdLimitacaoConsumoPerfil === 0 || !IdPerfil || IdPerfil === 0)) {
            setAlert({
                message: 'Não foi possível identificar a trava ou o perfil. Feche e abra novamente a edição.',
                type: 'error'
            })
            return
        }

        const loadingId = Math.random().toString()

        try {
            setLoading({
                id: loadingId,
                loading: true,
                message: 'Atualizando trava de consumo do perfil...'
            })

            await updateLimitacaoConsumoPerfilApi({
                IdLimitacaoConsumoPerfil,
                Quantidade,
                Ativo,
                IdUsuario: currentUser.IdUsuario,
                IdPerfil,
                IdGrupoTrava
            })

            dispatch(resetUpdateLimitacaoConsumoPerfilFormState())

            setAlert({
                message: 'Trava de consumo atualizada com sucesso',
                type: 'success'
            })

            navigateTo({
                route: '/dashboard/trava/consumo'
            })

            dispatch(setUpdateLimitacaoConsumoPerfilOpenFormState(false))
            dispatch(resetLimitacaoConsumoState())
            dispatch(resetClienteSelecionadoState())
            dispatch(resetUsuarioSelecionadoState())
            dispatch(resetPerfilSelecionadoState())
        } catch (error: any) {
            setAlert({
                message: getApiErrorMessage(error),
                type: 'error'
            })
        } finally {
            setLoading({
                id: loadingId,
                loading: false
            })
        }
    }, [currentUser, dispatch, navigateTo, setAlert, setLoading, updateLimitacaoConsumoPerfilApi, updateLimitacaoConsumoPerfilForm.fields])

    const setCreateLimitacaoConsumoPerfilOpenForm = useCallback((data: { open: boolean; IdPerfil?: number }) => {
        if (data.open) {
            dispatch(resetCreateLimitacaoConsumoPerfilFormState())
            dispatch(setCreateLimitacaoConsumoPerfilOpenFormState(true))
            if (data.IdPerfil) {
                dispatch(setCreateLimitacaoConsumoPerfilFormIdPerfilState(data.IdPerfil))
            }
            if (currentUser?.IdUsuario) {
                dispatch(setCreateLimitacaoConsumoPerfilFormIdUsuarioState(currentUser.IdUsuario))
            }
            navigateTo({ route: '/dashboard/trava/consumo/perfil/novo' })
        } else {
            dispatch(resetCreateLimitacaoConsumoPerfilFormState())
            dispatch(setCreateLimitacaoConsumoPerfilOpenFormState(false))
            navigateTo({ route: '/dashboard/trava/consumo' })
        }
    }, [currentUser?.IdUsuario, dispatch, navigateTo])

    const setCreateLimitacaoConsumoPerfilFormIdPerfil = useCallback((data: { IdPerfil: number }) => {
        dispatch(setCreateLimitacaoConsumoPerfilFormIdPerfilState(data.IdPerfil))
    }, [dispatch])

    const setCreateLimitacaoConsumoPerfilFormIdUsuario = useCallback((data: { IdUsuario: number }) => {
        dispatch(setCreateLimitacaoConsumoPerfilFormIdUsuarioState(data.IdUsuario))
    }, [dispatch])

    const setCreateLimitacaoConsumoPerfilFormIdProduto = useCallback((data: { IdProduto: number }) => {
        dispatch(setCreateLimitacaoConsumoPerfilFormIdProdutoState(data.IdProduto))
    }, [dispatch])

    const setCreateLimitacaoConsumoPerfilFormIdTipoConsumo = useCallback((data: { IdTipoConsumo: number[] }) => {
        dispatch(setCreateLimitacaoConsumoPerfilFormIdTipoConsumoState(data.IdTipoConsumo))
    }, [dispatch])

    const setCreateLimitacaoConsumoPerfilFormIsGrupo = useCallback((data: { IsGrupo: boolean }) => {
        dispatch(setCreateLimitacaoConsumoPerfilFormIsGrupoState(data.IsGrupo))
    }, [dispatch])

    const setCreateLimitacaoConsumoPerfilFormQuantidade = useCallback((data: { Quantidade: number }) => {
        dispatch(setCreateLimitacaoConsumoPerfilFormQuantidadeState(data.Quantidade))
    }, [dispatch])

    const submitCreateLimitacaoConsumoPerfil = useCallback(async () => {
        const porVariavel = (createLimitacaoConsumoPerfilForm.fields.IdTipoConsumo ?? []).length > 0
        const qtdTiposSelecionados = createLimitacaoConsumoPerfilForm.fields.IdTipoConsumo?.length || 0
        const quantidade = createLimitacaoConsumoPerfilForm.fields.Quantidade

        if (quantidade <= 0) {
            setAlert({
                message: 'A quantidade deve ser maior ou igual a 1',
                type: 'error'
            })
            return
        }

        if (porVariavel && !createLimitacaoConsumoPerfilForm.fields.IsGrupo && qtdTiposSelecionados > 0 && quantidade < qtdTiposSelecionados) {
            setAlert({
                message: `A quantidade deve ser de pelo menos ${qtdTiposSelecionados} para os tipos de consumo selecionados.`,
                type: 'error'
            })
            return
        }

        if (!porVariavel && (!createLimitacaoConsumoPerfilForm.fields.IdProduto || createLimitacaoConsumoPerfilForm.fields.IdProduto === 0)) {
            setAlert({
                message: 'Selecione um produto',
                type: 'error'
            })
            return
        }

        await createLimitacaoConsumoPerfil({
            IdPerfil: createLimitacaoConsumoPerfilForm.fields.IdPerfil,
            Quantidade: quantidade,
            IdProduto: (porVariavel && !createLimitacaoConsumoPerfilForm.fields.IsGrupo) ? null : createLimitacaoConsumoPerfilForm.fields.IdProduto,
            IdTipoConsumo: porVariavel ? (createLimitacaoConsumoPerfilForm.fields.IdTipoConsumo ?? []) : null,
            IsGrupo: createLimitacaoConsumoPerfilForm.fields.IsGrupo
        })
    }, [createLimitacaoConsumoPerfil, createLimitacaoConsumoPerfilForm.fields, setAlert])

    const setUpdateLimitacaoConsumoPerfilOpenForm = useCallback((data: {
        open: boolean
        ativo?: boolean
        idLimitacaoConsumoPerfil?: number
        idPerfil?: number
        quantidade?: number
        idGrupoTrava?: number
    }) => {
        if (data.open) {
            if (
                data.ativo !== undefined
                && (data.idLimitacaoConsumoPerfil || data.idGrupoTrava)
                && data.quantidade != null
                && data.idPerfil
            ) {
                dispatch(setUpdateLimitacaoConsumoPerfilOpenFormState(true))
                dispatch(setUpdateLimitacaoConsumoPerfilFormIdPerfilState(data.idPerfil))
                dispatch(setUpdateLimitacaoConsumoPerfilFormAtivoState(data.ativo))
                if (data.idLimitacaoConsumoPerfil) {
                    dispatch(setUpdateLimitacaoConsumoPerfilFormIdLimitacaoConsumoPerfilState(data.idLimitacaoConsumoPerfil))
                }
                if (data.idGrupoTrava) {
                    dispatch(setUpdateLimitacaoConsumoPerfilFormIdGrupoTravaState(data.idGrupoTrava))
                }
                dispatch(setUpdateLimitacaoConsumoPerfilFormQuantidadeState(data.quantidade))
                navigateTo({ route: '/dashboard/trava/consumo/perfil/atualizar' })
            }
        } else {
            dispatch(resetUpdateLimitacaoConsumoPerfilFormState())
            dispatch(setUpdateLimitacaoConsumoPerfilOpenFormState(false))
            navigateTo({ route: '/dashboard/trava/consumo' })
        }
    }, [dispatch, navigateTo])

    const setUpdateLimitacaoConsumoPerfilFormQuantidade = useCallback((data: { Quantidade: number }) => {
        dispatch(setUpdateLimitacaoConsumoPerfilFormQuantidadeState(data.Quantidade))
    }, [dispatch])

    const setUpdateLimitacaoConsumoPerfilFormAtivo = useCallback((data: { Ativo: boolean }) => {
        dispatch(setUpdateLimitacaoConsumoPerfilFormAtivoState(data.Ativo))
    }, [dispatch])

    const findClientes = useCallback(async (data: {
        IdVendedor?: number
        LoginCliente?: string
        NomeFantasia?: string
        RazaoSocial?: string
        CNPJ?: string
    }) => {
        if (currentUser) {
            const loadingId = Math.random().toString()

            try {
                setLoading({
                    id: loadingId,
                    loading: true,
                    message: 'Buscando clientes...'
                })

                const clientesList = await getClientesListApi({
                    IdCliente: currentUser.IdCliente,
                    IdUsuario: currentUser.IdUsuario,
                    limit: 25,
                    page: 1,
                    IdVendedor: data.IdVendedor,
                    LoginCliente: data.LoginCliente,
                    NomeFantasia: data.NomeFantasia,
                    RazaoSocial: data.RazaoSocial,
                    CNPJ: data.CNPJ
                })

                dispatch(setLimitacaoConsumoClientesState({
                    clientes: clientesList.clientes
                }))
            } catch (error: any) {
                setAlert({
                    message: getApiErrorMessage(error),
                    type: 'error'
                })
            } finally {
                setLoading({
                    id: loadingId,
                    loading: false
                })
            }
        }
    }, [currentUser, dispatch, getClientesListApi, setAlert, setLoading])

    const findUsuarios = useCallback(async () => {
        if (currentUser) {
            if (clienteSelecionado) {
                const loadingId = Math.random().toString()

                try {
                    setLoading({
                        id: loadingId,
                        loading: true,
                        message: 'Buscando usuários...'
                    })

                    const findUsuarios = await getAllUsuariosAtivosByIdClienteApi({
                        IdClienteBusca: clienteSelecionado.IdCliente
                    })

                    dispatch(setLimitacaoConsumoUsuariosState(findUsuarios))

                } catch (error: any) {
                    setAlert({
                        message: getApiErrorMessage(error),
                        type: 'error'
                    })
                } finally {
                    setLoading({
                        id: loadingId,
                        loading: false
                    })
                }
            }
        }
    }, [clienteSelecionado, currentUser, dispatch, getAllUsuariosAtivosByIdClienteApi, setAlert, setLoading])

    const findPerfis = useCallback(async () => {
        if (currentUser) {
            if (clienteSelecionado) {
                const loadingId = Math.random().toString()

                try {
                    setLoading({
                        id: loadingId,
                        loading: true,
                        message: 'Buscando perfis...'
                    })

                    const resp = await getPerfisByIdClienteApi({
                        idCliente: clienteSelecionado.IdCliente,
                        limit: 1000,
                        page: 1
                    })

                    dispatch(setLimitacaoConsumoPerfisState(resp.perfis))
                } catch (error: any) {
                    dispatch(resetLimitacaoConsumoPerfisState())
                    setAlert({
                        message: getApiErrorMessage(error),
                        type: 'error'
                    })
                } finally {
                    setLoading({
                        id: loadingId,
                        loading: false
                    })
                }
            }
        }
    }, [clienteSelecionado, currentUser, dispatch, getPerfisByIdClienteApi, setAlert, setLoading])

    const setPerfilSelecionado = useCallback((data: { perfilSelecionado: any }) => {
        dispatch(setPerfilSelecionadoState(data.perfilSelecionado))
    }, [dispatch])

    const resetPerfilSelecionado = useCallback(() => {
        dispatch(resetPerfilSelecionadoState())
    }, [dispatch])

    const getProdutoLimitacaoConsumoList = useCallback(async () => {
        if (currentUser) {
            const loadingId = Math.random.toString()

            try {
                setLoading({
                    id: loadingId,
                    loading: true,
                    message: 'Buscando produtos disponíveis...'
                })

                const getProdutosList = await produtoLimitacaoConsumoGetAllAtivosApi()

                dispatch(setProdutoLimitacaoConsumoListState(getProdutosList))
            } catch (error: any) {
                setAlert({
                    message: getApiErrorMessage(error),
                    type: 'error'
                })
            } finally {
                setLoading({
                    id: loadingId,
                    loading: false
                })
            }
        }
    }, [currentUser, dispatch, produtoLimitacaoConsumoGetAllAtivosApi, setAlert, setLoading])

    const setLimitacaoConsumoPagination = useCallback((data: {
        page: number
        limit: number
    }) => {
        dispatch(setLimitacaoConsumoPaginationState({
            limit: data.limit,
            page: data.page
        }))
    }, [dispatch])

    const setLimitacaoConsumoPage = useCallback((data: {
        page: number
    }) => {
        dispatch(setLimitacaoConsumoPageState(data.page))
    }, [dispatch])

    const setLimitacaoConsumoLimit = useCallback((data: {
        limit: number
    }) => {
        dispatch(setLimitacaoConsumoLimitState(data.limit))
    }, [dispatch])

    const resetLimitacaoConsumoPagination = useCallback(() => {
        dispatch(resetLimitacaoConsumoPaginationState())
    }, [dispatch])

    const setCreateLimitacaoConsumoClienteFormIdCliente = useCallback((data: {
        IdCliente: number
    }) => {
        dispatch(setCreateLimitacaoConsumoClienteFormIdClienteState(data.IdCliente))
    }, [dispatch])

    const setCreateLimitacaoConsumoClienteFormIdProduto = useCallback((data: {
        IdProduto: number
    }) => {
        dispatch(setCreateLimitacaoConsumoClienteFormIdProdutoState(data.IdProduto))
    }, [dispatch])

    const setCreateLimitacaoConsumoClienteFormModoTravaCliente = useCallback((data: {
        ModoTravaCliente: IModoTravaCliente
    }) => {
        dispatch(setCreateLimitacaoConsumoClienteFormModoTravaClienteState(data.ModoTravaCliente))
    }, [dispatch])

    const setCreateLimitacaoConsumoClienteFormIdTipoConsumo = useCallback((data: {
        IdTipoConsumo: number[]
    }) => {
        dispatch(setCreateLimitacaoConsumoClienteFormIdTipoConsumoState(data.IdTipoConsumo))
    }, [dispatch])

    const setCreateLimitacaoConsumoClienteFormQuantidade = useCallback((data: {
        Quantidade: number
    }) => {
        dispatch(setCreateLimitacaoConsumoClienteFormQuantidadeState(data.Quantidade))
    }, [dispatch])

    const setCreateLimitacaoConsumoClienteFormIdUsuario = useCallback((data: {
        IdUsuario: number
    }) => {
        dispatch(setCreateLimitacaoConsumoClienteFormIdUsuarioState(data.IdUsuario))
    }, [dispatch])

    const setCreateLimitacaoConsumoClienteFormIsGrupo = useCallback((data: {
        IsGrupo: boolean
    }) => {
        dispatch(setCreateLimitacaoConsumoClienteFormIsGrupoState(data.IsGrupo))
    }, [dispatch])


    const setUpdateLimitacaoConsumoClienteFormIdLimitacaoConsumoCliente = useCallback((data: {
        IdLimitacaoConsumoCliente: number
    }) => {
        dispatch(setUpdateLimitacaoConsumoClienteFormIdLimitacaoConsumoClienteState(data.IdLimitacaoConsumoCliente))
    }, [dispatch])

    const setUpdateLimitacaoConsumoClienteFormAtivo = useCallback((data: {
        Ativo: boolean
    }) => {
        dispatch(setUpdateLimitacaoConsumoClienteFormAtivoState(data.Ativo))
    }, [dispatch])

    const setUpdateLimitacaoConsumoClienteFormQuantidade = useCallback((data: {
        Quantidade: number
    }) => {
        dispatch(setUpdateLimitacaoConsumoClienteFormQuantidadeState(data.Quantidade))
    }, [dispatch])

    const setCreateLimitacaoConsumoClienteOpenForm = useCallback((data: {
        open: boolean
    }) => {
        if (data.open) {
            if (clienteSelecionado) {
                // Resetar o formulário antes de abrir (garantir campos zerados)
                dispatch(resetCreateLimitacaoConsumoClienteFormState())
                dispatch(setCreateLimitacaoConsumoClienteOpenFormState(true))
                dispatch(setCreateLimitacaoConsumoClienteFormIdClienteState(clienteSelecionado.IdCliente))
                navigateTo({
                    route: '/dashboard/trava/consumo/cliente/novo'
                })
            }
        } else {
            dispatch(resetCreateLimitacaoConsumoClienteFormState())
            dispatch(setCreateLimitacaoConsumoClienteOpenFormState(false))
            navigateTo({
                route: '/dashboard/trava/consumo'
            })
        }
    }, [clienteSelecionado, dispatch, navigateTo])

    const setUpdateLimitacaoConsumoClienteOpenForm = useCallback((data: {
        open: boolean
        ativo?: boolean
        idLimitacaoConsumoCliente?: number
        quantidade?: number
        idCliente?: number
        idGrupoTrava?: number
    }) => {
        if (data.open) {
            if (data.ativo !== undefined && data.idLimitacaoConsumoCliente && data.quantidade !== undefined) {
                dispatch(setUpdateLimitacaoConsumoClienteOpenFormState(true))
                dispatch(setUpdateLimitacaoConsumoClienteFormAtivoState(data.ativo))
                dispatch(setUpdateLimitacaoConsumoClienteFormIdLimitacaoConsumoClienteState(data.idLimitacaoConsumoCliente))
                dispatch(setUpdateLimitacaoConsumoClienteFormQuantidadeState(data.quantidade))
                if (data.idCliente) dispatch(setUpdateLimitacaoConsumoClienteFormIdClienteState(data.idCliente))
                if (data.idGrupoTrava) dispatch(setUpdateLimitacaoConsumoClienteFormIdGrupoTravaState(data.idGrupoTrava))
                navigateTo({
                    route: '/dashboard/trava/consumo/cliente/atualizar'
                })
            }
        } else {
            dispatch(resetUpdateLimitacaoConsumoClienteFormState())
            dispatch(setUpdateLimitacaoConsumoClienteOpenFormState(false))
            navigateTo({
                route: '/dashboard/trava/consumo'
            })
        }
    }, [dispatch, navigateTo])

    const setCreateLimitacaoConsumoUsuarioFormIdUsuario = useCallback((data: {
        IdUsuario: number
    }) => {
        dispatch(setCreateLimitacaoConsumoUsuarioFormIdUsuarioState(data.IdUsuario))
    }, [dispatch])

    const setCreateLimitacaoConsumoUsuarioFormIdProduto = useCallback((data: {
        IdProduto: number
    }) => {
        dispatch(setCreateLimitacaoConsumoUsuarioFormIdProdutoState(data.IdProduto))
    }, [dispatch])

    const setCreateLimitacaoConsumoUsuarioFormIdTipoConsumo = useCallback((data: {
        IdTipoConsumo: number[]
    }) => {
        dispatch(setCreateLimitacaoConsumoUsuarioFormIdTipoConsumoState(data.IdTipoConsumo))
    }, [dispatch])

    const setCreateLimitacaoConsumoUsuarioFormIsGrupo = useCallback((data: {
        IsGrupo: boolean
    }) => {
        dispatch(setCreateLimitacaoConsumoUsuarioFormIsGrupoState(data.IsGrupo))
    }, [dispatch])

    const setCreateLimitacaoConsumoUsuarioFormQuantidade = useCallback((data: {
        Quantidade: number
    }) => {
        dispatch(setCreateLimitacaoConsumoUsuarioFormQuantidadeState(data.Quantidade))
    }, [dispatch])

    const setUpdateLimitacaoConsumoUsuarioFormIdLimitacaoConsumoUsuario = useCallback((data: {
        IdLimitacaoConsumoUsuario: number
    }) => {
        dispatch(setUpdateLimitacaoConsumoUsuarioFormIdLimitacaoConsumoUsuarioState(data.IdLimitacaoConsumoUsuario))
    }, [dispatch])

    const setUpdateLimitacaoConsumoUsuarioFormAtivo = useCallback((data: {
        Ativo: boolean
    }) => {
        dispatch(setUpdateLimitacaoConsumoUsuarioFormAtivoState(data.Ativo))
    }, [dispatch])

    const setUpdateLimitacaoConsumoUsuarioFormQuantidade = useCallback((data: {
        Quantidade: number
    }) => {
        dispatch(setUpdateLimitacaoConsumoUsuarioFormQuantidadeState(data.Quantidade))
    }, [dispatch])

    const setCreateLimitacaoConsumoUsuarioOpenForm = useCallback((data: {
        open: boolean
    }) => {
        if (data.open) {
            if (usuarioSelecionado) {
                // Resetar o formulário antes de abrir (garantir campos zerados)
                dispatch(resetCreateLimitacaoConsumoUsuarioFormState())
                dispatch(setCreateLimitacaoConsumoUsuarioOpenFormState(true))
                dispatch(setCreateLimitacaoConsumoUsuarioFormIdUsuarioState(usuarioSelecionado.IdUsuario))
                navigateTo({
                    route: '/dashboard/trava/consumo/usuario/novo'
                })
            }
        } else {
            dispatch(resetCreateLimitacaoConsumoUsuarioFormState())
            dispatch(setCreateLimitacaoConsumoUsuarioOpenFormState(false))
            navigateTo({
                route: '/dashboard/trava/consumo'
            })
        }
    }, [usuarioSelecionado, dispatch, navigateTo])

    const setUpdateLimitacaoConsumoUsuarioOpenForm = useCallback((data: {
        open: boolean
        ativo?: boolean
        idLimitacaoConsumoUsuario?: number
        quantidade?: number
        idUsuario?: number
        idGrupoTrava?: number
    }) => {
        if (data.open) {
            if (data.ativo !== undefined && (data.idLimitacaoConsumoUsuario || data.idGrupoTrava) && data.quantidade != null) {
                dispatch(setUpdateLimitacaoConsumoUsuarioOpenFormState(true))
                dispatch(setUpdateLimitacaoConsumoUsuarioFormAtivoState(data.ativo))
                if (data.idLimitacaoConsumoUsuario) {
                    dispatch(setUpdateLimitacaoConsumoUsuarioFormIdLimitacaoConsumoUsuarioState(data.idLimitacaoConsumoUsuario))
                }
                if (data.idGrupoTrava) {
                    dispatch(setUpdateLimitacaoConsumoUsuarioFormIdGrupoTravaState(data.idGrupoTrava))
                }
                const idUser = data.idUsuario || usuarioSelecionado?.IdUsuario
                if (idUser) {
                    dispatch(setUpdateLimitacaoConsumoUsuarioFormIdUsuarioState(idUser))
                }
                dispatch(setUpdateLimitacaoConsumoUsuarioFormQuantidadeState(data.quantidade))
                navigateTo({
                    route: '/dashboard/trava/consumo/usuario/atualizar'
                })
            }
        } else {
            dispatch(resetUpdateLimitacaoConsumoUsuarioFormState())
            dispatch(setUpdateLimitacaoConsumoUsuarioOpenFormState(false))
            navigateTo({
                route: '/dashboard/trava/consumo'
            })
        }
    }, [dispatch, navigateTo, usuarioSelecionado])

    const resetLimitacaoConsumoTotal = useCallback(() => {
        dispatch(resetLimitacaoConsumoTotalState())
    }, [dispatch])

    const setClienteSelecionado = useCallback((data: {
        clienteSelecionado: ICliente
    }) => {
        dispatch(setClienteSelecionadoState(data.clienteSelecionado))
        dispatch(resetUsuarioSelecionadoState())
        dispatch(resetPerfilSelecionadoState())
    }, [dispatch])

    const resetClienteSelecionado = useCallback(() => {
        dispatch(resetClienteSelecionadoState())
        dispatch(resetUsuarioSelecionadoState())
        dispatch(resetPerfilSelecionadoState())
    }, [dispatch])

    const setUsuarioSelecionado = useCallback((data: {
        usuarioSelecionado: Omit<IUsuario, "Senha">
    }) => {
        dispatch(setUsuarioSelecionadoState(data.usuarioSelecionado))
    }, [dispatch])

    const resetUsuarioSelecionado = useCallback(() => {
        dispatch(resetUsuarioSelecionadoState())
    }, [dispatch])

    const resetProdutoLimitacaoConsumoList = useCallback(() => {
        dispatch(resetProdutoLimitacaoConsumoListState())
    }, [dispatch])

    const resetLimitacaoConsumoList = useCallback(() => {
        dispatch(resetLimitacaoConsumoState())
    }, [dispatch])

    const resetCreateLimitacaoConsumoClienteForm = useCallback(() => {
        dispatch(resetCreateLimitacaoConsumoClienteFormState())
    }, [dispatch])

    const resetCreateLimitacaoConsumoUsuarioForm = useCallback(() => {
        dispatch(resetCreateLimitacaoConsumoUsuarioFormState())
    }, [dispatch])

    // Buscar todas as travas ativas do cliente (para validação)
    const findAllActiveLimitacaoConsumoCliente = useCallback(async (idCliente: number): Promise<ILimitacaoConsumoTable[]> => {
        if (!currentUser) return []

        try {
            // Buscar com limite alto para pegar todas as travas
            const clientList = await findLimitacaoConsumoClienteApi({
                IdCliente: idCliente,
                IdUsuario: currentUser.IdUsuario,
                Limit: 10000, // Limite alto para pegar todas
                Page: 1
            })

            const limitacaoConsumoList: ILimitacaoConsumoTable[] = []

            const rows = clientList?.LimitacaoConsumo ?? []
            rows.forEach((limitacaoConsumo) => limitacaoConsumoList.push({
                Ativo: limitacaoConsumo.Ativo,
                Atualizacao: limitacaoConsumo.Atualizacao,
                Descricao: limitacaoConsumo.Descricao,
                DescricaoProduto:
                    limitacaoConsumo.DescricaoProduto ??
                    (limitacaoConsumo.IdProduto != null && limitacaoConsumo.Descricao ? limitacaoConsumo.Descricao : null),
                IdLimitacaoConsumo: limitacaoConsumo.IdLimitacaoConsumoCliente ?? limitacaoConsumo.IdGrupoTrava,
                IdGrupoTrava: limitacaoConsumo.IdGrupoTrava,
                IdProduto: limitacaoConsumo.IdProduto ?? null,
                IdTipoConsumo: limitacaoConsumo.IdTipoConsumo ?? null,
                Inclusao: limitacaoConsumo.Inclusao,
                Login: limitacaoConsumo.LoginCliente,
                Quantidade: limitacaoConsumo.Quantidade,
                IdCliente: limitacaoConsumo.IdCliente,
                IdUsuario: currentUser.IdUsuario
            }))

            // Retornar apenas as travas ativas
            return limitacaoConsumoList.filter(trava => trava.Ativo === true)
        } catch (error) {
            return []
        }
    }, [currentUser, findLimitacaoConsumoClienteApi])

    // Buscar todas as travas ativas do usuário (para validação)
    const findAllActiveLimitacaoConsumoUsuario = useCallback(async (idUsuario: number): Promise<ILimitacaoConsumoTable[]> => {
        if (!currentUser) return []

        try {
            // Buscar com limite alto para pegar todas as travas
            const list = await findLimitacaoConsumoUsuarioApi({
                IdUsuario: idUsuario,
                Limit: 10000, // Limite alto para pegar todas
                Page: 1
            })

            const limitacaoConsumoList: ILimitacaoConsumoTable[] = []

            list.LimitacaoConsumo.forEach((limitacaoConsumo) => limitacaoConsumoList.push({
                Ativo: limitacaoConsumo.Ativo,
                Atualizacao: limitacaoConsumo.Atualizacao,
                Descricao: limitacaoConsumo.Descricao,
                IdLimitacaoConsumo: limitacaoConsumo.IdLimitacaoConsumoUsuario,
                IdProduto: limitacaoConsumo.IdProduto ?? null,
                IdTipoConsumo:limitacaoConsumo.IdTipoConsumo ?? null,
                Inclusao: limitacaoConsumo.Inclusao,
                Login: limitacaoConsumo.LoginUsuario,
                Quantidade: limitacaoConsumo.Quantidade,
                IdUsuario: limitacaoConsumo.IdUsuario,
                IdCliente: currentUser.IdCliente,
                IdGrupoTrava: limitacaoConsumo.IdGrupoTrava
            }))

            // Retornar apenas as travas ativas
            return limitacaoConsumoList.filter(trava => trava.Ativo === true)
        } catch (error) {
            return []
        }
    }, [currentUser, findLimitacaoConsumoUsuarioApi])

    const findAllActiveLimitacaoConsumoPerfil = useCallback(async (idPerfil: number): Promise<ILimitacaoConsumoTable[]> => {
        if (!currentUser) return []

        try {
            const list = await findLimitacaoConsumoPerfilApi({
                IdPerfil: idPerfil,
                Limit: 10000,
                Page: 1
            })

            const limitacaoConsumoList: ILimitacaoConsumoTable[] = []
            const rows = list?.LimitacaoConsumo ?? []
            rows.forEach((row: any) => limitacaoConsumoList.push({
                Ativo: row.Ativo,
                Atualizacao: row.Atualizacao,
                Descricao: row.Descricao,
                DescricaoProduto: row.DescricaoProduto ?? null,
                IdLimitacaoConsumo: row.IdLimitacaoConsumoPerfil,
                IdProduto: row.IdProduto ?? null,
                IdTipoConsumo: row.IdTipoConsumo ?? null,
                Inclusao: row.Inclusao,
                Login: row.DescricaoPerfil,
                Quantidade: row.Quantidade,
                IdUsuario: currentUser.IdUsuario,
                IdCliente: currentUser.IdCliente,
                IdGrupoTrava: row.IdGrupoTrava
            }))

            return limitacaoConsumoList.filter(trava => trava.Ativo === true)
        } catch {
            return []
        }
    }, [currentUser, findLimitacaoConsumoPerfilApi])

    return {
        createLimitacaoConsumoCliente,
        updateLimitacaoConsumoCliente,
        findLimitacaoConsumoCliente,
        findClientes,
        findUsuarios,
        findPerfis,
        setLimitacaoConsumoPagination,
        setLimitacaoConsumoPage,
        setLimitacaoConsumoLimit,
        resetLimitacaoConsumoPagination,
        setCreateLimitacaoConsumoClienteFormIdCliente,
        setCreateLimitacaoConsumoClienteFormIdUsuario,
        setCreateLimitacaoConsumoClienteFormIdProduto,
        setCreateLimitacaoConsumoClienteFormModoTravaCliente,
        setCreateLimitacaoConsumoClienteFormIdTipoConsumo,
        setCreateLimitacaoConsumoClienteFormQuantidade,
        setCreateLimitacaoConsumoClienteFormIsGrupo,
        setUpdateLimitacaoConsumoClienteFormIdLimitacaoConsumoCliente,
        setUpdateLimitacaoConsumoClienteFormAtivo,
        setUpdateLimitacaoConsumoClienteFormQuantidade,
        setCreateLimitacaoConsumoClienteOpenForm,
        setUpdateLimitacaoConsumoClienteOpenForm,
        resetLimitacaoConsumoTotal,
        setClienteSelecionado,
        resetClienteSelecionado,
        setCreateLimitacaoConsumoUsuarioFormIdUsuario,
        setCreateLimitacaoConsumoUsuarioFormIdProduto,
        setCreateLimitacaoConsumoUsuarioFormIdTipoConsumo,
        setCreateLimitacaoConsumoUsuarioFormIsGrupo,
        setCreateLimitacaoConsumoUsuarioFormQuantidade,
        setUpdateLimitacaoConsumoUsuarioFormIdLimitacaoConsumoUsuario,
        setUpdateLimitacaoConsumoUsuarioFormAtivo,
        setUpdateLimitacaoConsumoUsuarioFormQuantidade,
        setCreateLimitacaoConsumoUsuarioOpenForm,
        setUpdateLimitacaoConsumoUsuarioOpenForm,
        createLimitacaoConsumoUsuario,
        updateLimitacaoConsumoUsuario,
        findLimitacaoConsumoUsuario,
        findLimitacaoConsumoPerfil,
        createLimitacaoConsumoPerfil,
        updateLimitacaoConsumoPerfil,
        setCreateLimitacaoConsumoPerfilOpenForm,
        setCreateLimitacaoConsumoPerfilFormIdPerfil,
        setCreateLimitacaoConsumoPerfilFormIdUsuario,
        setCreateLimitacaoConsumoPerfilFormIdProduto,
        setCreateLimitacaoConsumoPerfilFormIdTipoConsumo,
        setCreateLimitacaoConsumoPerfilFormIsGrupo,
        setCreateLimitacaoConsumoPerfilFormQuantidade,
        submitCreateLimitacaoConsumoPerfil,
        setUpdateLimitacaoConsumoPerfilOpenForm,
        setUpdateLimitacaoConsumoPerfilFormQuantidade,
        setUpdateLimitacaoConsumoPerfilFormAtivo,
        setUsuarioSelecionado,
        resetUsuarioSelecionado,
        setPerfilSelecionado,
        resetPerfilSelecionado,
        getProdutoLimitacaoConsumoList,
        resetProdutoLimitacaoConsumoList,
        resetLimitacaoConsumoList,
        resetCreateLimitacaoConsumoClienteForm,
        resetCreateLimitacaoConsumoUsuarioForm,
        findAllActiveLimitacaoConsumoCliente,
        findAllActiveLimitacaoConsumoUsuario,
        findAllActiveLimitacaoConsumoPerfil
    }
}